<template>
    <div>
        <!-- Display the Description of the table -->
        <div ref="QrCodeMultipleRef">            
            <div 
              class="qr-code-multiple"
              v-for="item in selectedQrCodes" :key="item.LocationId"
            >
              <div class = "tableurl dx-field center-text">
                {{item.TableURL.substring(0, item.TableURL.length-6)}}<span class="code">{{item.TableURL.substring(item.TableURL.length, item.TableURL.length-6)}}</span>
              </div>
              <div class = "dx-field center-text qr-tablename">
                {{item.TableName}}
              </div>

              <QrCode                 
                class="qr-code-image"
                ref="QrCodeImageRef" 
                :value.sync="item.TableURL"
              />
            </div>
          </div>
    </div>
</template>

<script>

import shared from '../utils/contact-tracing-functions';
import DxButton from "devextreme-vue/button";
import DxPopupReg from 'devextreme-vue/popup';
import QrCode from 'vue-qrcode'
import { DxItem } from 'devextreme-vue/form';

export default {
    components: {
        DxButton,
        QrCode,
        DxItem,
        DxPopupReg,
    },
    props: {
        popupVisible: Boolean,
        selectedQrCodes: Array,
    },
    data() {
        return {              
            qrCodeButtonAttr: {
                class: 'qr-code-button'
            },
            selectedCodes: this.selectedQrCodes
        };
    },
    mounted(){

    },
    methods: {

    }        
}
</script>

<style scoped>
  @import '../themes/contact-tracing.css';

  /* Format the QR images as a grid/table */
  .qr-code-multiple{
   
    display:inline-table; /* inline-flex could also work */
    /*border: 1px;
    border-style:dashed;*/
    padding-top: 30px;
    padding-bottom: 30px;

    width:300px;
    height:300px;

    visibility: hidden;
  }

  /* Center the QR image */
  .qr-code-image{
    margin:auto;
    display:block;
  }

  /* Padding for the tableURL that appears above each QR image */
  .tableurl{
    padding:20px;
  }
</style>